import React from 'react';
import ContentParser from 'src/ui/library/ContentParser';
import { transformFormValues } from 'src/helpers/';
import Layout from 'src/ui/layout';
import TableAddRemoveExample from './TableAddRemoveExample';
import Result from 'src/ui/library/ContentParser/data/ResultBug.json';

export default function ServiceAddPres({ organizerData }) {
  const mockData = Result;
  console.log(mockData);

  const onChange = data => {
    const { formValues } = data;
    console.log(transformFormValues(formValues));
  };

  return (
    <Layout headerName={'CMS Sandbox'}>
      <div className="margin-content">
        <div className="content-parser">
          <TableAddRemoveExample />
          <ContentParser key={20} pageId={20} numberOfColumns={2} data={mockData} showLabels={false} debug={false} onChange={onChange} />
        </div>
      </div>
    </Layout>
  );
}
